module.exports = __webpack_public_path__ + "img/manchester-city.e1c05943.png";